<template>
  <div class="container-fluid">
    <b-card class="shadow p-3 bg-white rounded m-4"  no-body>
      <b-tabs pills vertical>
        <b-tab  title="Manajemen Produk" active>
          <b-card class="shadow-sm p-3 mb-5 bg-white rounded">
            <b-card-text>Manajemen Produk</b-card-text>
          </b-card>
        </b-tab>
        <b-tab title="Mitra profil" active>
          <b-card class="shadow-sm p-3 mb-5 bg-white rounded">
            <b-card-text>Mitra Profil</b-card-text>
          </b-card>
        </b-tab>
        <b-tab  title="Manajemen Pengajuan" active>
          <b-card class="shadow-sm p-3 mb-5 bg-white rounded">
            <b-card-text>Manajemen pengajuan</b-card-text>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
}
</script>

<style scoped>
  .container-fluid {
    padding-top: 100px;

  }
</style>



// WEBPACK FOOTER //
// src/components/tabs.vue